import { compose } from 'recompose';

import ClientsFilter from './ClientsFilter';

const enhance = compose();

export default enhance(ClientsFilter);
